export default __webpack_public_path__ + "static/media/happy-bunch-4.3bc846a6.svg";